import { render, staticRenderFns } from "./OrderCustomerDetails.vue?vue&type=template&id=00429cc3&"
import script from "./OrderCustomerDetails.vue?vue&type=script&lang=js&"
export * from "./OrderCustomerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports